import axios from "axios";

const CLOUDINARY_PRESET = "ml_default";
const CLOUDINARY_CLOUDENAME = "dzmbym5t2";

const videoUploader = async (video) => {
  if (!video) {
    console.log("Please select a video first.");
    return "";
  }

  try {
    const formData = new FormData();
    formData.append("file", video);
    formData.append("upload_preset", CLOUDINARY_PRESET);

    const response = await axios.post(
      `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUDENAME}/video/upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data", // Make sure to add this header
        },
      }
    );

    const videoUrl = response.data.secure_url;
    console.log(videoUrl);
    return videoUrl;
  } catch (error) {
    console.error("Error uploading video:", error);
    return "Error uploading video. Please try again later.";
  }
};

export default videoUploader;
